import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getVerisoulSession } from '@/common/verisoul';
import { setSessionId, setValidationResult } from '@/redux/slices/sessionValidation';

const host = import.meta.env.VITE_BE_HOST;

export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${host}/api`,
  }),
  endpoints: (builder) => ({
    storeEmail: builder.mutation({
      query: (emailData) => ({
        url: 'https://5v2466zfe0.execute-api.us-east-1.amazonaws.com/store-email',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: emailData,
      }),
    }),
    getPublicRewards: builder.query({
      query: () => ({
        url: '/rewards/',
        method: 'GET',
      }),
    }),
    checkUnauthenticatedSession: builder.mutation({
      async queryFn(_, api, ___, baseQuery) {
        // Get Verisoul session_id
        let sessionId = null;
        try {
          const session = await getVerisoulSession();
          sessionId = session?.session_id || null;

          // Store session ID in Redux
          if (sessionId) {
            api.dispatch(setSessionId(sessionId));
          }
        } catch (error) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: 'Session not available',
            },
          };
        }

        if (!sessionId) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: 'Session ID is required',
            },
          };
        }

        const result = await baseQuery({
          url: '/session/check',
          method: 'POST',
          body: { session_id: sessionId },
        });

        if (result.error) {
          return { error: result.error };
        }

        // Store validation result in Redux for unauthenticated users
        if (result.data) {
          api.dispatch(
            setValidationResult({
              result: result.data,
              type: 'unauthenticated',
            }),
          );
        }

        return { data: result.data };
      },
    }),
  }),
});

export const {
  useStoreEmailMutation,
  useGetPublicRewardsQuery,
  useCheckUnauthenticatedSessionMutation,
} = publicApi;
